import React, { Component } from "react"
import { connect } from 'react-redux'
import moment from 'moment'
import $ from 'jquery'
import { Input, Select, Div, Tablecell, DropDownList, InputDecimal } from "../core";
import utilityHelper from '../../helpers/helperUtil'
import tableHelper from '../../helpers/tableHelper'
import {
    updateGR_ServiceLineModalAction,
    updateGR_ServiceLineAction,
    updateGR_ServiceAccountAssignmentAction,
} from '../../redux/actions/GRAction'
import {
    getCostCenterAction,
    getGLAccountAction,
    getBusinessInformationAction,
    GETEWHTConditionValidationCheckInquiryAction,
    getPlantInfoAction,
    getUOMAction,
    getAssetClassAction

} from '../../redux/actions/MasterAction'
import {
    setAssetModalOptionAction
} from '../../redux/actions/AssetAction'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from "@material-ui/core/TablePagination";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import head_acc_assignment from './datas/head_acc_assignment.json'
import {
    data_t_GR_SERVICELINE,
    data_t_IR_ITEM_ACCOUNT_ASSIGNMENT
} from '../../configs/datas'
import { data_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT } from '../../configs/datas'
import {
    SearchAssetModal,
    SearchIOModal,
    NewAsset
} from '../../components'
import { msg } from "../Notifications/MsgBox"
import { MessageText } from "../../configs";
import { updateNewAssetAction } from '../../redux/actions/MainAction'
import { setModalCostCenterKeyAction } from '../../redux/actions/ModalCostCenterAction'
import assetHelper from '../../helpers/assetHelper'
import {
    EVENT_COST_CENTER_SELECTED,
    EVENT_CURRENT_SERVICELINE_SELECTED
} from '../../configs/EventTypes'
const numeral = require('numeral')

class ServiceLineModal extends Component {

    constructor(props) {
        super(props)
        this.state = {

            serviceLineModal: {
                index: null,
                serviceItemNo: null,
                viewmode: null,
                lastLineNo: null,
                item: {}
            },
            selectItemGRService: {},
            docType: '',
            showCreateAssetClassType: false,
            showAccountAssignment: true,
            showServiceLine: true,
            order: "asc",
            orderBy: "",
            page: 0,
            rowsPerPage: 5,
            headAccountAssignment: head_acc_assignment,
            editQty: false,
            editPerce: false,
            accountAssignment: [],
            local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: data_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
            editIndex: null,
            ctrObj: null,
            gl_accounts_selectList: [],
            cost_centers_selectList: [],
            _viewMode: false,
            modalCostCenterKey: "ServiceLineModal",
            isContract: false,

            plants: [],
            unit_uoms: [],
            assetClasses: [],
        }

        this.handleChange = this.handleChange.bind(this)
        this.createAssetClassType = this.createAssetClassType.bind(this)
        this.saveServiceLine = this.saveServiceLine.bind(this)
        this.newAccountAssignment = this.newAccountAssignment.bind(this)
        this.getSumAccountAssignment = this.getSumAccountAssignment.bind(this)
        this.getNextServiceLineNo = this.getNextServiceLineNo.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.openAssetModal = this.openAssetModal.bind(this)
        this.handleSelectAsset = this.handleSelectAsset.bind(this)
        this.handleSelectIO = this.handleSelectIO.bind(this)
        this.openIOModal = this.openIOModal.bind(this)
        this.saveAsset = this.saveAsset.bind(this)
        this.openCCModal = this.openCCModal.bind(this)
        this.closeModal = this.closeModal.bind(this)


        window.emitter.addListener(EVENT_COST_CENTER_SELECTED, this.handleCostCenterSelected.bind(this))
        window.emitter.addListener(EVENT_CURRENT_SERVICELINE_SELECTED, this.setCurrentServiceLine.bind(this))
    }

    closeModal() {
        let { showCreateAssetClassType, local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT, serviceLineModal } = this.state
        let index = !serviceLineModal ? null : serviceLineModal.index
        let lastLineNo = !serviceLineModal ? null : serviceLineModal.lastLineNo

        if (showCreateAssetClassType !== true) {
            if (index === "") {
                if (lastLineNo === "0") {
                    local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.map((item, _index) => {
                        if (item.item_no + "" === serviceLineModal.serviceItemNo + "" && item.acc_id == null) {
                            item.service_line_no = serviceLineModal.lastLineNo
                        }
                    })

                } else {
                    local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.pop()

                }
            }
            this.setState({
                serviceLineModal: {
                    item: {}
                },
                accountAssignment: [],
                local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT
            })

            window.$('#serviceLineModal').modal('hide')
        } else {
            this.goBack()
        }
    }

    componentDidMount() {
        // this.props.getCostCenter()
        //     .then((response) => {
        //         this.setState({
        //             cost_centers_selectList: utilityHelper.toSelectList2(response.data, "description", "cosT_CENTER")
        //         })
        //     })

        // this.props.getGLAccount()
        //     .then((response) => {
        //         this.setState({
        //             gl_accounts_selectList: utilityHelper.toSelectList2(response.data, "shorT_TEXT", "gL_ACCOUNT_NO")
        //         })
        //     })
    }

    setCurrentServiceLine(data) {
        const {
            po_no,
            t_GR_SERVICELINE,
            t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT
        } = this.props
        let getServiceActountAssingment = null;
        let { selectItemGRService, serviceLineModal } = data

        let index = !serviceLineModal ? null : serviceLineModal.index
        let serviceItemNo = !serviceLineModal ? null : serviceLineModal.serviceItemNo
        let viewmode = !serviceLineModal ? null : serviceLineModal.viewmode
        let lastLineNo = !serviceLineModal ? null : serviceLineModal.lastLineNo
        let docementType = !serviceLineModal ? null : serviceLineModal.docementType
        let is_contract = !serviceLineModal ? null : serviceLineModal.is_contract
        serviceLineModal.item = t_GR_SERVICELINE[index]

        this.setState({
            serviceLineModal: {
                ...this.state.serviceLineModal,
                index: index,
                item: {
                    ...serviceLineModal.item
                }
            },
            selectItemGRService: selectItemGRService,
            local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
        })

        let accountAssignment = []

        if (index !== "") {

            this.setState({
                _viewMode: serviceLineModal.viewmode,
            })

            serviceLineModal.item = t_GR_SERVICELINE[index]
            t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.map((item, _index) => {
                if (serviceLineModal.item) {
                    if (item.service_line_no + "" === serviceLineModal.item.service_line_no + "" && item.item_no + "" === serviceLineModal.item.service_item_no + "") {
                        item._index = _index
                        accountAssignment.push(item)
                    }
                }
                else {
                    if (serviceItemNo === item.item_no) {
                        accountAssignment.push(item)
                    }
                }
            })
        } else {
            if (!serviceLineModal.item) {
                let lineNo = this.getNextServiceLineNo(selectItemGRService[0].service_item_id).toString()
                serviceLineModal.item = {
                    ...data_t_GR_SERVICELINE[0],
                    service_item_no: selectItemGRService[0].service_item_id,
                    service_line_no: lineNo.toString(),
                    currency: selectItemGRService[0].currency //t_GR_SERVICELINE[0].currency
                }
                let _serviceActountAssingment = {
                    ...data_t_IR_ITEM_ACCOUNT_ASSIGNMENT[0],
                    _index: t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT ? t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.length : 0,
                    item_no: selectItemGRService[0].service_item_id,
                    service_line_no: lineNo.toString(),
                }

                getServiceActountAssingment = t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.find(f => f.item_no + "" === serviceItemNo + "" && f.service_line_no + "" === lineNo.toString() && f.acc_id == null)

                if (!getServiceActountAssingment) {
                    getServiceActountAssingment = t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.sort().find(f => f.item_no + "" === serviceItemNo + "" && f.acc_id == null)
                }
                if (getServiceActountAssingment) {
                    _serviceActountAssingment = this.bindingServiceActountAssingment(getServiceActountAssingment, t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT, lineNo)
                }
                if (lineNo === "10") {
                    if (!getServiceActountAssingment) {
                        t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.push(_serviceActountAssingment)
                    }
                    t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.map((item, _index) => {
                        if (serviceItemNo === item.item_no && item.acc_id == null) {
                            item._index = t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT ? t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.length : 0
                            item.service_line_no = lineNo.toString()
                            item.checked = true
                            _serviceActountAssingment = item
                        }
                    })
                } else {
                    t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.push(_serviceActountAssingment)
                }
                accountAssignment.push(_serviceActountAssingment)
            } else {
                accountAssignment = this.state.accountAssignment
                serviceLineModal = this.state.serviceLineModal
            }
        }
        let docType = ''
        const selectitem = selectItemGRService
        if (selectitem.length > 0) {
            docType = utilityHelper.getDocType(
                po_no,
                selectitem[0].a,
                selectitem[0].i,
                selectitem[0].material,
                selectitem[0].overall_limit)
        }

        this.setState({
            docType: docType,
            serviceLineModal: {
                ...this.state.serviceLineModal,
                index: index,
                serviceItemNo: serviceItemNo,
                viewmode: viewmode,
                lastLineNo: lastLineNo,
                item: {
                    ...serviceLineModal.item
                }
            },
            isContract: is_contract,
            accountAssignment: accountAssignment
        })

        this.props.getGLAccount()
            .then((response) => {
                this.setState({
                    gl_accounts_selectList: utilityHelper.toSelectList2(response.data, "shorT_TEXT", "gL_ACCOUNT_NO")
                })
            })

        $(function () {
            window.onComponentDidMount()
        })
    }
    bindingServiceActountAssingment(serviceActountAssingment, t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT, lineNo) {
        let _serviceActountAssingment = {
            //running: serviceActountAssingment.running,
            running: 0,
            transaction_no: serviceActountAssingment.transaction_no,
            service_line_no: lineNo.toString(),
            sequence: serviceActountAssingment.sequence,
            acc_id: serviceActountAssingment.acc_id,
            checked: true,
            quantity: serviceActountAssingment.quantity,
            perce: serviceActountAssingment.perce,
            gl_acct: typeof (serviceActountAssingment.gl_acct_original) !== "undefined" && serviceActountAssingment.gl_acct_original !== serviceActountAssingment.gl_acct ? serviceActountAssingment.gl_acct_original : serviceActountAssingment.gl_acct,
            cost_center: typeof (serviceActountAssingment.gl_acct_original) !== "undefined" && serviceActountAssingment.cost_center_original !== serviceActountAssingment.cost_center ? serviceActountAssingment.cost_center_original : serviceActountAssingment.cost_center,
            asset: typeof (serviceActountAssingment.asset_original) !== "undefined" && serviceActountAssingment.asset_original !== serviceActountAssingment.asset ? serviceActountAssingment.asset_original : serviceActountAssingment.asset,
            acc_order: typeof (serviceActountAssingment.acc_order_original) !== "undefined" && serviceActountAssingment.acc_order_original !== serviceActountAssingment.acc_order ? serviceActountAssingment.acc_order_original : serviceActountAssingment.acc_order,
            asset_no: serviceActountAssingment.asset_no,
            asset_class: serviceActountAssingment.asset_class,
            asset_class_name: serviceActountAssingment.asset_class_name,
            no_of_similar_asset: serviceActountAssingment.no_of_similar_asset,
            asset_creation_flag: serviceActountAssingment.asset_creation_flag,
            asset_grouping: serviceActountAssingment.asset_grouping,
            asset_sub_grouping: serviceActountAssingment.asset_sub_grouping,
            asset_company_code: serviceActountAssingment.asset_company_code,
            asset_description_1: serviceActountAssingment.asset_description_1,
            asset_description_2: serviceActountAssingment.asset_description_2,
            asset_serial_number: serviceActountAssingment.asset_serial_number,
            asset_inventory_number: serviceActountAssingment.asset_inventory_number,
            asset_quantity: serviceActountAssingment.asset_quantity,
            asset_unit: serviceActountAssingment.asset_unit,
            asset_cost_center: serviceActountAssingment.asset_cost_center,
            asset_plant: serviceActountAssingment.asset_plant,
            license_plate_of_vehicle: serviceActountAssingment.nulicense_plate_of_vehiclell,
            asset_location: serviceActountAssingment.asset_location,
            personal_number: serviceActountAssingment.personal_number,
            asset_room: serviceActountAssingment.asset_room,
            start_sequence: serviceActountAssingment.start_sequence,
            item_no: serviceActountAssingment.item_no,
            acc_order_original: serviceActountAssingment.acc_order_original,
            gl_acc_original: serviceActountAssingment.gl_acc_original,
            cost_center_original: serviceActountAssingment.cost_center_original,
            asset_original: serviceActountAssingment.asset_original,
            _index: t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT ? t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.length : 0
        }
        return _serviceActountAssingment
    }

    handleChange(event) {
        //event.preventDefault()
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;
        const { isContract } = this.state;

        //check date
        if (target.className) {
            if ((target.className.indexOf("js-datepicker") > -1 || target.className.indexOf("js-datepicker-all") > -1) && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    }
                }
            }
        }

        if (name === 'receive_qty') {
            const { serviceLineModal } = this.state
            if (serviceLineModal.item) {
                let current = serviceLineModal.item
                if (current[name] != value) {
                    if (serviceLineModal.item.remaining_qty && isContract == false) {
                        let _remaining_qty = utilityHelper.parseFloat(serviceLineModal.item.remaining_qty)
                        let _receive_qty = utilityHelper.parseFloat(value)
                        if (_receive_qty <= 0) {
                            msg.error('กรุณาระบุ Receive Qty มากกว่า 0.000')
                        }
                        if (_remaining_qty > 0 && _receive_qty > _remaining_qty) {
                            msg.error('Receive Qty มากกว่า Remaining Qty กรุณาตรวจสอบข้อมูล')
                        }
                        else if (_receive_qty < _remaining_qty) {
                            msg.warning('Receive Qty น้อยกว่ายอด Remaining Qty')
                        }
                    }
                }
            }
        }
        if (name === 'distribution') {
            if (value === "1") {
                this.state.accountAssignment.map((data, index) => {
                    if (data.service_line_no === this.state.serviceLineModal.item.service_line_no) {
                        // this.props.updateServiceLineModalAccountAssignment("", index, 'perce')
                        this.setState({
                            accountAssignment: this.state.accountAssignment.map((data, a_index) => {
                                if (a_index === Number(index)) {
                                    let updateAccountAssignment = data
                                    updateAccountAssignment['perce'] = ""
                                    return updateAccountAssignment
                                } else {
                                    return data
                                }
                            })
                        })
                        if (index === 0) {
                            // this.props.updateServiceLineModalAccountAssignment(this.state.serviceLineModal.item.qty, index, 'quantity')
                            this.setState({
                                accountAssignment: this.state.accountAssignment.map((data, a_index) => {
                                    if (a_index === Number(index)) {
                                        let updateAccountAssignment = data
                                        updateAccountAssignment['quantity'] = this.state.serviceLineModal.item.qty
                                        return updateAccountAssignment
                                    } else {
                                        return data
                                    }
                                })
                            })
                            return ""
                        } else {
                            return ""
                        }
                    } else {
                        return ""
                    }
                })
                this.setState({
                    editQty: true,
                    editPerce: false
                })
            } else if (value === "2") {
                this.state.accountAssignment.map((_data, index) => {
                    // this.props.updateServiceLineModalAccountAssignment("", index, 'quantity')
                    this.setState({
                        accountAssignment: this.state.accountAssignment.map((data, a_index) => {
                            if (a_index === Number(index)) {
                                let updateAccountAssignment = data
                                updateAccountAssignment['quantity'] = ""
                                return updateAccountAssignment
                            } else {
                                return data
                            }
                        })
                    })
                    if (index === 0) {
                        // this.props.updateServiceLineModalAccountAssignment("100", index, 'perce')
                        this.setState({
                            accountAssignment: this.state.accountAssignment.map((data, a_index) => {
                                if (a_index === Number(index)) {
                                    let updateAccountAssignment = data
                                    updateAccountAssignment['perce'] = "100"
                                    return updateAccountAssignment
                                } else {
                                    return data
                                }
                            })
                        })
                        return ""
                    } else {
                        return ""
                    }
                })
                this.setState({
                    editQty: false,
                    editPerce: true
                })
            } else {
                this.setState({
                    editQty: false,
                    editPerce: false
                })
            }
        }
        else {
            if (valid) {
                const { serviceLineModal } = this.state
                let current = serviceLineModal.item
                if (current[name] != value) {
                    this.setState({
                        serviceLineModal: {
                            ...this.state.serviceLineModal,
                            item: {
                                ...this.state.serviceLineModal.item,
                                [name]: value
                            }
                        }
                    })
                }
            } else {
                return
            }
        }
    }

    handleChangeAccountAssignment(event, index, commited = false) {
        console.log("handleChangeAccountAssignment")
        //event.preventDefault()

        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;

        if (valid) {
            console.log("updateGR_ServiceAccountAssignment")
            this.setState({

                // local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT:
                //     this.state.local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.map((data, index_state) => {
                //         if (index_state == index) {
                //         let updateItem = data
                //         updateItem[name] = value
                //         return updateItem
                //         } else {
                //         return data
                //         }
                //     })

                accountAssignment:
                    this.state.accountAssignment.map((data, index_state) => {

                        // if (index_state == index) {
                        let updateItem = { ...data }
                        updateItem[name] = value
                        return updateItem
                        // } else {
                        // return data
                        // }
                    })


            })

            if (commited == true) {
                //this.props.updateGR_ServiceAccountAssignment(value, index, name)
            }
        } else {
            return
        }
    }

    async saveServiceLine() {
        const { serviceLineModal, accountAssignment } = this.state
        let { t_GR_SERVICE, t_GR_SERVICELINE, t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT } = this.props
        let serviceItemNo = ""
        if (typeof (serviceLineModal.item.service_item_no) !== 'undefined' || serviceLineModal.item.service_item_no != null) {
            serviceItemNo = serviceLineModal.item.service_item_no;
        } else {
            serviceItemNo = serviceLineModal.index
        }
        const serviceitem = t_GR_SERVICE.find(f => f.service_item_no == serviceItemNo)
        const overallLimit = serviceitem && serviceitem.overall_limit ? serviceitem.overall_limit : 0
        const { t_PO_DETAIL } = this.props
        let isCheckPo = false
        if (t_PO_DETAIL.po_contract_no.substr(0, 2) === "41" || t_PO_DETAIL.po_contract_no.substr(0, 3) === "322" || t_PO_DETAIL.po_contract_no.substr(0, 3) === "324" || Number(overallLimit) > 0) {
            isCheckPo = true
        }
        let checkAcc = false
        let checkAccMsg = ""
        let _qty = 0
        let _perce = 0
        accountAssignment && accountAssignment.map((acc, index) => {
            if (serviceitem && serviceitem.a === "A" && (!acc.asset || acc.asset === "") && isCheckPo) {
                checkAcc = true
                checkAccMsg = checkAccMsg + "กรุณาระบุ Asset <br/>"
            }
            if (!acc.gl_acct || acc.gl_acct === "") {
                checkAcc = true
                checkAccMsg = checkAccMsg + "กรุณาระบุ GL <br/>"
            }
            if (serviceitem && serviceitem.a === "F" && (!acc.cost_center || acc.cost_center === "") && (acc.acc_order && acc.acc_order.replace(/^0+/, '').length !== 9) && isCheckPo) {
                checkAcc = true
                checkAccMsg = checkAccMsg + "กรุณาระบุ Cost Center <br/>"
            }
            if (!acc.acc_order || acc.acc_order === "") {
                checkAcc = true
                checkAccMsg = checkAccMsg + "กรุณาระบุ Order <br/>"
            }
            _qty += utilityHelper.parseFloat(acc.quantity)
            _perce += utilityHelper.parseFloat(acc.perce)
        })
        if (checkAcc) {
            msg.error(checkAccMsg)
        }
        else {
            if (this.state.serviceLineModal.index === "") {
                let { t_GR_SERVICELINE } = this.props
                let { selectItemGRService } = this.state
                delete this.state.serviceLineModal.item[0];
                let ItemGRService = selectItemGRService[0];
                let data = this.state.serviceLineModal.item;

                let service_line_no_arr = [];
                t_GR_SERVICELINE.forEach(function (element) {
                    if (element.service_item_no == ItemGRService.service_item_no) {
                        service_line_no_arr.push(element.service_line_no);
                    }
                });
                console.log(service_line_no_arr);
                var service_line_no_next = 0;
                if (service_line_no_arr.length > 0) {
                    service_line_no_arr.sort(function (a, b) { return b - a });
                    service_line_no_next = (Number(service_line_no_arr[0]) + 10) + "";
                } else {
                    service_line_no_next = 10;
                }

                data.service_item_no = ItemGRService.service_item_no
                data.service_line_no = service_line_no_next
                data.checked = 1;

                //let hasServiceActountAssingment = t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.find(f => f.item_no === serviceItemNo && (f.service_line_no === null || f.service_line_no === "") && f.acc_id === null)
                //if (hasServiceActountAssingment) {
                //let data = t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.push(accountAssignment[0]);
                //this.props.updateGR_ServiceAccountAssignment(data)
                //} else {
                // await this.props.updateGR_ServiceAccountAssignment("remove", accountAssignment[0].item_no, accountAssignment[0].service_line_no)

                //this.props.updateGR_ServiceAccountAssignment(accountAssignment[0])
                //}

                await this.props.updateGR_ServiceLine(data)
                await this.props.updateGR_ServiceLineModal(data);

            } else {
                /*                 if (t_GR_SERVICELINE === null || t_GR_SERVICELINE.length === 0) {
                                    let data = this.state.serviceLineModal.item
                                    data.running = 0
                                    data.transaction_no = null
                                    data.service_line_id = null
                                    data.checked = true
                                    data.service_line_no = serviceItemNo
                                    data.service_item_no = serviceItemNo
                                    data.currency = serviceitem.currency
                                    await this.props.updateGR_ServiceLine(data)
                                } else if (((t_GR_SERVICELINE[0].running != '' || t_GR_SERVICELINE[0].running == 0) && t_GR_SERVICELINE[0].checked)) {
                                    let data = this.state.serviceLineModal.item
                                    data.running = 0
                                    data.transaction_no = null
                                    data.service_line_id = null
                                    data.checked = true
                                    data.service_line_no = serviceItemNo
                                    data.service_item_no = serviceItemNo
                                    data.currency = serviceitem.currency
                                    t_GR_SERVICELINE.push(data)
                                    await this.props.updateGR_ServiceLine(t_GR_SERVICELINE, "", "", true)
                                } else {
                                    await this.props.updateGR_ServiceLine(this.state.serviceLineModal.item, this.state.serviceLineModal.index)
                                }
                 */
                await this.props.updateGR_ServiceLine(this.state.serviceLineModal.item, this.state.serviceLineModal.index)
            }
            if (accountAssignment.length > 0) {
                await this.props.updateGR_ServiceAccountAssignment("remove", accountAssignment[0].item_no, accountAssignment[0].service_line_no)

                this.props.updateGR_ServiceAccountAssignment(accountAssignment[0])
            }
            this.setState({
                serviceLineModal: {
                    item: {}
                },
                accountAssignment: []
            })

            if (window.onServiceLineSaved) window.onServiceLineSaved()
            window.$('#serviceLineModal').modal('hide');
        }
    }

    async createAssetClassType() {
        await this.props.setAssetModalOption({
            poType: 'service'
        })

        window.$('#serviceLineModal').animate({ scrollTop: 0 }, 'slow');

        this.setState({
            showAccountAssignment: false,
            showServiceLine: false,
            showCreateAssetClassType: true
        })

        this.props.getAssetClass().then(response => {
            let result = utilityHelper.toSelectList(response.data, "display", "value")
            this.setState({ assetClasses: result })
        })

         this.props.getPlantInfo(null).then(response => {
            let result = utilityHelper.toSelectList_CombineFields(response.data, "planT_CODE", "planT_DESC", "planT_CODE")
            this.setState({ plants: result })
        })

        this.props.getUOM().then(response => {
            let result = utilityHelper.toSelectList_CombineFields(response.data, "commercial", "uniT_TEXT", "commercial")
            this.setState({ unit_uoms: result })
        })


    }

    async saveAsset(assetNew) {
        const {
            accountAssignment,
            serviceLineModal
        } = this.state
        const {
            t_NEW_ASSET,

        } = this.props

        const { selectItemGRService } = this.state

        let accountAssignmentUpdated = [...accountAssignment]

        if (!assetNew) return

        //Validations
        let start = 1
        let qty = 1

        if (assetNew.start_sequence && assetNew.start_sequence.length > 0) {
            start = parseInt(assetNew.start_sequence)
        }

        if (assetNew.no_of_similar_asset && assetNew.no_of_similar_asset.length > 0) {
            qty = parseInt(assetNew.no_of_similar_asset)
        }

        if (qty < 1) {
            msg.error(MessageText.PAGE.ASSET.MSG_NO_OF_SIMILAR_INVALID_ZERO)
            return
        }

        if (start < 1 || start > accountAssignment.length) {
            msg.error(MessageText.PAGE.ASSET.MSG_START_SEQUENCE_INVALID)
            return
        }
        //End of Validations

        let assetResult = assetHelper.generateAssets(assetNew, [...t_NEW_ASSET])
        let i = 0

        for (i = 0; i < qty; i++) {
            let asset_index = (start - 1) + i
            let asset = assetResult.assets_New[i]

            if (asset_index > accountAssignment.length - 1) {
                let itemGRService = selectItemGRService[0];
                let data = serviceLineModal.item;

                let service_line_no = data.service_line_no;
                let service_item_no = itemGRService.service_item_no;

                let acc_id_arr = [];

                accountAssignment.forEach(function (element) {
                    if (element.item_no == service_item_no && element.service_line_no == service_line_no) {
                        acc_id_arr.push(element.acc_id);
                    }
                });

                acc_id_arr.sort(function (a, b) { return b - a });
                let acc_id_next = Number(acc_id_arr[0]) + 10;
                let newAccountAssignment = {
                    ...data_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT[0],
                    service_line_no: service_line_no,
                    item_no: service_item_no,
                    acc_id: acc_id_next,
                    asset: asset.asset_no,
                    asset_no: asset.asset_no,
                    asset_creation_flag: true
                }

                if (accountAssignment.length == 0) {
                    accountAssignmentUpdated.push(newAccountAssignment)
                }
                else {
                    accountAssignmentUpdated[0] = newAccountAssignment
                }
            } else {
                accountAssignmentUpdated[asset_index].asset = asset.asset_no
                accountAssignmentUpdated[asset_index].asset_no = asset.asset_no
                accountAssignmentUpdated[asset_index].asset_creation_flag = true
            }
        }
        await this.setState({
            accountAssignment: accountAssignmentUpdated,
            showAccountAssignment: true,
            showServiceLine: true,
            showCreateAssetClassType: false
        })
        this.props.updateNewAsset(assetResult.assets_All)
    }

    goBack() {
        if (this.state.showCreateAssetClassType) {
            this.setState({
                showAccountAssignment: true,
                showServiceLine: true,
                showCreateAssetClassType: false
            })
        }
    }

    newAccountAssignment() {
        let ItemGRService = this.props.selectItemGRService[0];
        let data = this.state.serviceLineModal.item;

        let service_line_no = data.service_line_no;
        let service_item_no = ItemGRService.service_item_no;

        let acc_id_arr = [];
        this.state.accountAssignment.forEach(function (element) {
            if (element.item_no == service_item_no && element.service_line_no == service_line_no) {
                console.log(element);
                acc_id_arr.push(element.acc_id);
            }
        });


        acc_id_arr.sort(function (a, b) { return b - a });
        let acc_id_next = Number(acc_id_arr[0]) + 10;
        console.log("service_line_no: " + service_line_no);
        console.log("service_item_no: " + service_item_no);
        //console.log(this.state.accountAssignment)
        //let item_new = data_t_GR_ITEM_ACCOUNT_ASSIGNMENT[0];
        let item_new = {};
        item_new.service_line_no = service_line_no;
        item_new.item_no = service_item_no;
        //item_new.transaction_no = "T228";
        // item_new.acc_id = "20";
        item_new.acc_id = acc_id_next;

        //window.$('#AccountAssignModal').modal('show');
        //this.props.updateServiceLineModalAccountAssignment(newData)
        this.props.updateGR_ServiceAccountAssignment(item_new)
    }

    getSumAccountAssignment() {
        let count = 0
        this.state.accountAssignment.map((item) => {
            if (item.service_line_no === this.state.serviceLineModal.item.service_line_no) {
                count = count + 1
            }
            return ""
        })
        return count
    }

    getNextServiceLineNo(service_item_no) {
        let { t_GR_SERVICELINE } = this.props
        console.log("getNextServiceLineNo");
        console.log(t_GR_SERVICELINE);
        console.log("service_item_no:" + service_item_no);
        console.log(this.state.items);
        let lastNo = 0
        t_GR_SERVICELINE.map((serviceLine, _index) => {

            if (serviceLine.service_item_no === service_item_no && utilityHelper.parseInt(serviceLine.service_line_no) > utilityHelper.parseInt(lastNo)) {
                lastNo = serviceLine.service_line_no
            }
        })
        this.setState({
            serviceLineModal: {
                lastLineNo: Number(lastNo)
            }
        })

        return (Number(lastNo) + 10)
    }


    // // Grid start

    // desc(a, b, orderBy) {
    //     if (b[orderBy] < a[orderBy]) {
    //         return -1;
    //     }
    //     if (b[orderBy] > a[orderBy]) {
    //         return 1;
    //     }
    //     return 0;
    // }

    // stableSort(array, cmp) {
    //     if (typeof (array) !== "undefined" && typeof (array) !== "") {
    //         const stabilizedThis = array && array.map((el, index) => [el, index]);
    //         stabilizedThis.sort((a, b) => {
    //             const order = cmp(a[0], b[0]);
    //             if (order !== 0) return order;
    //             return a[1] - b[1];
    //         });
    //         return stabilizedThis.map(el => el[0]);
    //     }
    // }

    // getSorting(order, orderBy) {
    //     return order === "desc"
    //         ? (a, b) => this.desc(a, b, orderBy)
    //         : (a, b) => -this.desc(a, b, orderBy);
    // }

    // handleRequestSort(event, property) {
    //     const isDesc = this.state.orderBy === property && this.state.order === "desc";
    //     this.setState({
    //         order: isDesc ? "asc" : "desc",
    //         orderBy: property
    //     })
    // }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        })
    }

    handleChangeRowsPerPage(event) {
        this.setState({
            rowsPerPage: +event.target.value,
            page: 0
        })
    }

    // Grid end
    openAssetModal(event, index) {
        this.setState({
            editIndex: index
        })

        window.$('#searchAssetModal').modal('show');
    }

    openIOModal(event, index) {
        this.setState({
            editIndex: index
        })
        window.$('#searchIOModal').modal('show');
    }

    openCCModal(event, index) {
        const { modalCostCenterKey } = this.state

        this.setState({
            ...this.state,
            editIndex: index,
            //ctrObj:event
        })

        this.props.setModalCostCenterKey(modalCostCenterKey)

        window.$('#searchCostCenterModal').modal('show');
    }

    handleSelectAsset(value) {
        console.log("handleChangeAccountAssignment")
        let {
            editIndex,
            accountAssignment
        } = this.state
        //event.preventDefault()

        const index = editIndex

        if (value) {
            console.log("handleSelectAsset")

            let updateItem = { ...accountAssignment[0] } //local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT[index]

            if (value.indexOf("NEW") != -1) {
                //new asset
                updateItem.asset_creation_flag = true
                updateItem.asset = value
                updateItem.asset_no = value
            } else {
                updateItem.asset_creation_flag = false
                updateItem.asset = value
            }

            //local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT[index]=updateItem
            accountAssignment[0] = updateItem
            this.setState({
                //local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT
                accountAssignment: accountAssignment
            })
            //this.props.updateGR_ServiceAccountAssignment(value, index, name)

        } else {
            return
        }
    }

    handleSelectIO(value) {
        console.log("handleSelectIO")

        let {
            editIndex,
            accountAssignment
        } = this.state
        //event.preventDefault()

        const index = editIndex

        if (value) {

            let updateItem = { ...accountAssignment[0] }//local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT[index]

            updateItem.acc_order = value
            if (value.length === 9) {
                updateItem.cost_center = ""
            }

            //local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT[index]=updateItem
            accountAssignment[0] = updateItem
            this.setState({
                //local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT
                accountAssignment: accountAssignment
            })
            //this.props.updateGR_ServiceAccountAssignment(value, index, name)

        } else {
            return
        }
    }

    handleCostCenterSelected(refKey, obj) {
        //console.log("handleSelectIO")
        let {
            editIndex,
            accountAssignment,
            modalCostCenterKey
        } = this.state
        //event.preventDefault()

        let value = obj;
        const index = editIndex

        if (modalCostCenterKey !== refKey) return

        if (value) {
            //console.log("handleSelectIO")
            this.setState({

                accountAssignment:
                    accountAssignment.map((data, index_state) => {
                        if (index_state == index) {
                            let updateItem = { ...data }
                            updateItem.cost_center = value
                            return updateItem
                        } else {
                            return data
                        }
                    })
            })
            //this.props.updateGR_ServiceAccountAssignment(value, index, name)

        } else {
            return
        }
    }

    getUnitUOM() {
        let result = null
        const { unit_uom } = this.props
        if (unit_uom) {
            //result = utilityHelper.toSelectList(unit_uom, "commercial", "commercial")
            result = utilityHelper.toSelectList_CombineFields(unit_uom, "commercial", "uniT_TEXT", "commercial")
        }
        return result
    }

    render() {
        // console.log("ServiceLineModal.render()")
        // console.log("accountAssignment:")
        // console.log(this.state.accountAssignment)
        const {
            docType,
            serviceLineModal,
            selectItemGRService,
            showServiceLine,
            accountAssignment,
            showAccountAssignment,
            headAccountAssignment,
            showCreateAssetClassType,
            gl_accounts_selectList,
            _viewMode,
            order,
            orderBy,
            page,
            rowsPerPage,
            editQty,
            editPerce
        } = this.state

        const {
            po_no,
            currency_code_data,
        } = this.props

        let { viewMode } = this.props
        viewMode = _viewMode ? true : viewMode

        const createSortHandler = property => event => {
            this.handleRequestSort(event, property);
        };

        return (
            <div className="modal fade sp-modal rrs-modal" id="serviceLineModal" tabIndex={-1} role="dialog" aria-labelledby="serviceLineModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="serviceLineModalLabel">{showCreateAssetClassType !== true ? "Service Line" : "Create Asset"}</h5>
                            <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        {serviceLineModal.item && (<div className="modal-body">
                            <div className="rrs-detail-data sp-table-container">
                                <div className="row align-items-center mx-0">
                                    <div className="col-md-12 col-lg-12 pr-md-5 pl-0">
                                        Purchase Order PO / Contract Number : {po_no}
                                    </div>
                                </div>
                                {showServiceLine && (<div id="div_serviceLineInfo" className="rrs-detail">
                                    <div className="rrs-detail header-item-acc">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <h5 className="text-header-item-acc">Service Line Information</h5>
                                            </div>
                                            <div className="col-md-4">
                                                <h6 className="text-header-item-acc mt-1">Line : {serviceLineModal.item.service_line_no}</h6>
                                            </div>
                                        </div>
                                    </div>

                                    {/* <div className="collapse show" id="collapseItemInfo"> */}
                                    <div className="rrs-detail pt-2 pb-3 px-3 item-information">
                                        <div className="row">
                                            <Div className="col-md-4" doctype={docType} tagid="gr.sevice_line.Short_Text">
                                                <div className="rrs-form">
                                                    <label htmlFor="short_text" id="lbl-gr_sevice_line_short_text" className="rrs-label">Short Text</label>
                                                    <div className="rrs-detail-data">
                                                        <label htmlFor="cc" id="lblsub-gr_sevice_line_short_text" className="rrs-label">(ชื่อกิจกรรมงานบริการ)</label>
                                                    </div>
                                                    <div className="rrs-detail-data" key={serviceLineModal.item.short_text}>
                                                        <Input
                                                            type="text"
                                                            name="short_text"
                                                            defaultValue={serviceLineModal.item.short_text || ''}
                                                            className="short_text"
                                                            id="short_text"
                                                            onBlur={this.handleChange}
                                                            doctype={docType}
                                                            tagid="gr.sevice_line.Short_Text"
                                                            viewMode={viewMode}
                                                            maxlength="40"
                                                        />
                                                    </div>
                                                </div>
                                            </Div>
                                            <Div className="col-md-4" doctype={docType} tagid="gr.service_line.unit">
                                                <div className="rrs-form">
                                                    <div className="rrs-detail-data content-hide">
                                                        <label htmlFor="cc" className="rrs-label">|</label>
                                                    </div>
                                                    <label htmlFor="unit" id="lbl-gr_service_line_unit" className="rrs-label">Unit </label>
                                                    <div className="rrs-detail-data">
                                                        <DropDownList
                                                            key={`serviceLineModal_${serviceLineModal.item.service_line_no}_${serviceLineModal.item.unit}`}
                                                            id="unit"
                                                            name="unit"
                                                            className="text-left unit"
                                                            options={this.getUnitUOM()}
                                                            selected={serviceLineModal.item.unit}
                                                            onSelectChanged={this.handleChange}
                                                            doctype={docType}
                                                            tagid="gr.service_line.unit"
                                                            viewMode={viewMode}
                                                        >
                                                        </DropDownList>
                                                    </div>
                                                </div>
                                            </Div>
                                        </div>

                                        <div className="row">
                                            <Div className="col-md-4" doctype={docType} tagid="gr.service_line.qty">
                                                <div className="rrs-form">
                                                    <label htmlFor="qty" id="lbl-gr_service_line_qty" className="rrs-label">Qty </label>
                                                    <div className="rrs-detail-data">
                                                        <label htmlFor="cc" id="lblsub-gr_service_line_qty" className="rrs-label">(ปริมาณกิจกรรมงานบริการ)</label>
                                                    </div>
                                                    <div className="rrs-detail-data">
                                                        <Input
                                                            key={`serviceLineModal_${serviceLineModal.item.service_line_no}_${serviceLineModal.item.qty}`}
                                                            type="text"
                                                            name="qty"
                                                            pattern="[0-9.,]*"
                                                            defaultValue={numeral(serviceLineModal.item.qty).format('0,0.000')}
                                                            className="qty"
                                                            id="qty"
                                                            onBlur={this.handleChange}
                                                            doctype={docType}
                                                            tagid="gr.service_line.qty"
                                                            inputMode="decimal"
                                                            step="0,0.000"
                                                            floatingPoint={3}
                                                            viewMode={viewMode}
                                                        />
                                                    </div>
                                                </div>
                                            </Div>
                                            <Div className="col-md-4" doctype={docType} tagid="gr.service_line.remaining_qty">
                                                <div className="rrs-form">
                                                    <label htmlFor="remaining_qty" id="lbl-gr_service_line_remaining_qty" className="rrs-label">Remaining Qty </label>
                                                    <div className="rrs-detail-data">
                                                        <label htmlFor="cc" id="lblsub-gr_service_line_remaining_qty" className="rrs-label">(ปริมาณคงเหลือที่ทำรับได้)</label>
                                                    </div>
                                                    <div className="rrs-detail-data">
                                                        <InputDecimal
                                                            key={`serviceLineModal_${serviceLineModal.item.service_line_no}_${serviceLineModal.item.remaining_qty}`}
                                                            type="text"
                                                            name="remaining_qty"
                                                            pattern="[0-9.,]*"
                                                            defaultValue={numeral(serviceLineModal.item.remaining_qty).format('0,0.000') || ''}
                                                            className="remaining_qty form-control text-right"
                                                            id="remaining_qty"
                                                            inputMode="decimal"
                                                            step="0,0.000"
                                                            floatingPoint={3}
                                                            onBlur={this.handleChange}
                                                            doctype={docType}
                                                            tagid="gr.service_line.remaining_qty"
                                                            viewMode={viewMode}
                                                        />
                                                    </div>
                                                </div>
                                            </Div>
                                            <Div className="col-md-4" doctype={docType} tagid="gr.sevice_line.receive_qty">
                                                <div className="rrs-form">
                                                    <label htmlFor="receive_qty" id="lbl-gr_sevice_line_receive_qty" className="rrs-label">Receive Qty </label>
                                                    <div className="rrs-detail-data">
                                                        <label htmlFor="cc" id="lblsub-gr_sevice_line_receive_qty" className="rrs-label">(ปริมาณที่ต้องการทำรับ)</label>
                                                    </div>
                                                    <div className="rrs-detail-data">

                                                        <InputDecimal
                                                            key={`serviceLineModal_${serviceLineModal.item.service_line_no}_${serviceLineModal.item.receive_qty}`}
                                                            tagid="gr.sevice_line.receive_qty"
                                                            doctype={docType}
                                                            type="text"
                                                            name="receive_qty"
                                                            pattern="[0-9.,]*"
                                                            defaultValue={serviceLineModal.item.receive_qty ? (numeral(serviceLineModal.item.receive_qty).format('0,0.000')) : ""}
                                                            className="form-control text-right"
                                                            id="receive_qty"
                                                            onBlur={this.handleChange}
                                                            inputMode="decimal"
                                                            step="0,0.000"
                                                            floatingPoint={3}
                                                            viewMode={viewMode}
                                                            validate_required={false}
                                                        />

                                                    </div>
                                                </div>
                                            </Div>
                                        </div>

                                        <div className="row">
                                            <Div className="col-md-4" doctype={docType} tagid="gr.sevice_line.gross_price">
                                                <div className="rrs-form">
                                                    <label htmlFor="gross_price" id="lbl-gr_sevice_line_gross_price" className="rrs-label">Gross Price </label>
                                                    <div className="rrs-detail-data">
                                                        <label htmlFor="cc" id="lblsub-gr_sevice_line_gross_price" className="rrs-label">(ราคาต่อหน่วย)</label>
                                                    </div>
                                                    <div className="rrs-detail-data">

                                                        <InputDecimal
                                                            key={`serviceLineModal_${serviceLineModal.item.service_line_no}_${serviceLineModal.item.gross_price}`}
                                                            tagid="gr.sevice_line.gross_price"
                                                            doctype={docType}
                                                            type="text"
                                                            name="gross_price"
                                                            pattern="[0-9.,]*"
                                                            defaultValue={numeral(serviceLineModal.item.gross_price).format('0,0.00')}
                                                            className="form-control text-right"
                                                            id="gross_price"
                                                            onBlur={this.handleChange}
                                                            inputMode="decimal"
                                                            step="0,0.00"
                                                            floatingPoint={2}
                                                            viewMode={viewMode}
                                                        />

                                                    </div>
                                                </div>
                                            </Div>
                                            <Div className="col-md-4" doctype={docType} tagid="gr.service_line.currency">
                                                <div className="rrs-form">
                                                    <div className="rrs-detail-data content-hide">
                                                        <label htmlFor="cc" className="rrs-label">|</label>
                                                    </div>
                                                    <label htmlFor="currency" id="lbl-gr_service_line_currency" className="rrs-label">Currency </label>
                                                    <div className="rrs-detail-data">
                                                        <Select
                                                            name="currency"
                                                            value={serviceLineModal.item.currency || ''}
                                                            className="form-control-small currency"
                                                            id="currency"
                                                            onChange={this.handleChange}
                                                            doctype={docType}
                                                            tagid="gr.service_line.currency"
                                                            viewMode={viewMode}
                                                        >
                                                            {currency_code_data && currency_code_data.map((currencyCodeData, index) => (
                                                                <option key={index} value={currencyCodeData.currencY_CODE}>{currencyCodeData.currencY_CODE}</option>
                                                            ))}
                                                        </Select>
                                                    </div>
                                                </div>
                                            </Div>
                                        </div>
                                    </div>
                                    {/* </div> */}
                                </div>)}
                                {(showAccountAssignment) && (<div className="div_account_assignment">
                                    <div className="rrs-detail header-item-acc">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <h5 className="text-header-item-acc">Account Assignment</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row no-gutters sp-table-content">
                                        <Table aria-labelledby="tableTitle" className="sp-table table rrs-table">
                                            <TableHead>
                                                <TableRow className="sp-table-header">
                                                    {/* <TableCell className="th-table text-center">
                                                        Delete
                                                    </TableCell> */}
                                                    {headAccountAssignment.map((row, index) => (
                                                        <Tablecell
                                                            tagid={row.tagid}
                                                            doctype={docType}
                                                            className="th-table"
                                                            key={row.id}
                                                            align={row.numeric ? "right" : "left"}
                                                            padding={row.disablePadding ? "none" : "default"}
                                                            sortDirection={orderBy === row.id ? order : false}
                                                        >
                                                            {!row.disableSort && (<TableSortLabel
                                                                active={orderBy === row.id}
                                                                direction={order}
                                                                onClick={createSortHandler(row.id)}
                                                            >
                                                                <div style={{ width: row.width }} className="th-text">{row.label}</div>
                                                                {orderBy === row.id ? (
                                                                    <span
                                                                        style={{
                                                                            border: 0,
                                                                            clip: "rect(0 0 0 0)",
                                                                            height: 1,
                                                                            margin: -1,
                                                                            overflow: "hidden",
                                                                            padding: 0,
                                                                            position: "absolute",
                                                                            top: 20,
                                                                            width: 1
                                                                        }}
                                                                    >
                                                                        {order === "desc"
                                                                            ? "sorted descending"
                                                                            : "sorted ascending"}
                                                                    </span>
                                                                ) : null}
                                                            </TableSortLabel>)}
                                                            {row.disableSort && (
                                                                <div style={{ width: row.width }} className="th-text">{row.label}</div>
                                                            )}
                                                        </Tablecell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {tableHelper.stableSort(accountAssignment, tableHelper.getSorting(order, orderBy))
                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    .map((row, index) => {
                                                        // if (row.service_line_no === this.state.serviceLineModal.item.service_line_no) {
                                                        let prnoByItem = selectItemGRService.find(f => f.service_item_no === row.item_no)
                                                        let prnoPrefix = prnoByItem !== null && prnoByItem.pr_no !== null && prnoByItem.pr_no !== "" ? prnoByItem.pr_no.substring(0, 3) : ""
                                                        let prnoPrefixs = [119, 118]
                                                        let hasPrnoPrefixs = prnoPrefixs.some(s => s == prnoPrefix)
                                                        return (
                                                            <TableRow
                                                                hover
                                                                tabIndex={-1}
                                                                key={"service_account_assigment_" + index + "_" + row.acc_id}
                                                            >
                                                                {/* <TableCell className="action-icon">
                                                                    <button
                                                                        className="btn"
                                                                        onClick={() => { this.props.onHandleDelete("t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT", row) }}
                                                                        disabled={false}
                                                                    >
                                                                        <i className="icon btn-trash" />
                                                                    </button>
                                                                </TableCell> */}

                                                                <TableCell>
                                                                    <label className="label-full text-grid">{index + 1}</label>
                                                                </TableCell>
                                                                <Tablecell tagid="gr.acc_ass.quantity" doctype={docType}>
                                                                    {editQty && (
                                                                        <Input
                                                                            tagid="gr.acc_ass.quantity"
                                                                            doctype={docType}
                                                                            type="text"
                                                                            name={"quantity"}
                                                                            value={row.quantity}
                                                                            className="quantity"
                                                                            id="quantity"
                                                                            onChange={(event) => this.handleChangeAccountAssignment(event, index)}
                                                                            onBlur={(event) => this.handleChangeAccountAssignment(event, index, true)}
                                                                            viewMode={viewMode}
                                                                        />
                                                                    )}
                                                                    {!editQty && (
                                                                        <label className="label-full text-grid">{row.quantity}</label>
                                                                    )}
                                                                </Tablecell>
                                                                <Tablecell tagid="gr.acc_ass.perce" doctype={docType}>
                                                                    {editPerce && (
                                                                        <Input
                                                                            tagid="gr.acc_ass.perce"
                                                                            doctype={docType}
                                                                            type="text"
                                                                            name={"perce"}
                                                                            value={row.perce}
                                                                            className="perce"
                                                                            id="perce"
                                                                            onChange={(event) => this.handleChangeAccountAssignment(event, index)}
                                                                            onBlur={(event) => this.handleChangeAccountAssignment(event, index, true)}
                                                                            viewMode={viewMode}
                                                                        />
                                                                    )}
                                                                    {!editPerce && (
                                                                        <label className="label-full text-grid">{row.perce}</label>
                                                                    )}
                                                                </Tablecell>
                                                                <Tablecell tagid="gr.acc_ass.gl_acct" doctype={docType}>
                                                                    {/* {row.checked === 1 && ( */}
                                                                    {/* <Select
                                                                        tagid="gr.acc_ass.gl_acct"
                                                                        doctype={docType}
                                                                        name={"gl_acct"}
                                                                        id={"gl_acct" + index}
                                                                        value={row.gl_acct}
                                                                        onChange={(event) => this.handleChangeAccountAssignment(event, row._index)}
                                                                        onBlur={(event) => this.handleChangeAccountAssignment(event, row._index, true)}
                                                                        className="gl_acct">
                                                                        <option key={0} value={"-"}>{"-"}</option>
                                                                        {this.props.gl_account_data && this.props.gl_account_data.map((glAccount, index) => (
                                                                            <option key={index + 1} value={glAccount.gL_ACCOUNT_NO}>{parseInt(glAccount.gL_ACCOUNT_NO) + " " + glAccount.shorT_TEXT}</option>
                                                                        ))}
                                                                    </Select> */}
                                                                    <DropDownList
                                                                        tagid="gr.acc_ass.gl_acct"
                                                                        doctype={docType}
                                                                        name="gl_acct"
                                                                        id={"gl_acct" + index}
                                                                        options={gl_accounts_selectList}
                                                                        onSelectChanged={(event) => this.handleChangeAccountAssignment(event, index)}
                                                                        selected={row.gl_acct}
                                                                        viewMode={viewMode}
                                                                    >
                                                                    </DropDownList>
                                                                    {/* )}
                                                                    {(row.checked === 0 || row.checked === "") && (row.gl_acct)} */}
                                                                </Tablecell>
                                                                <Tablecell tagid="gr.acc_ass.cost_center" doctype={docType}>
                                                                    {/* {row.checked === 1 && ( */}

                                                                    <Input
                                                                        key={"service_account_assigment_" + index + "_" + row.cost_center}
                                                                        type="text"
                                                                        name={"cost_center"}
                                                                        value={row.cost_center || ''}
                                                                        className={`form-control w-100 ${viewMode ? '' : ' searchable'}`}
                                                                        autocomplete="off"
                                                                        id="cost_center"
                                                                        onChange={(event) => this.handleChangeAccountAssignment(event, index)}
                                                                        doctype={docType}
                                                                        tagid="gr.acc_ass.cost_center"
                                                                        onClick={(event) => this.openCCModal(event, index)}
                                                                        viewMode={viewMode}
                                                                        readOnly={true}
                                                                    />
                                                                    {/* <DropDownList
                                                                        tagid="gr.acc_ass.cost_center"
                                                                        doctype={docType}
                                                                        name="cost_center"
                                                                        id={"cost_center" + index}
                                                                        options={cost_centers_selectList}
                                                                        onSelectChanged={(event) => this.handleChangeAccountAssignment(event, row._index)}
                                                                        selected={row.cost_center}
                                                                        viewMode={viewMode}
                                                                    >
                                                                    </DropDownList> */}
                                                                    {/* )}
                                                                    {(row.checked === 0 || row.checked === "") && (row.cost_center)} */}
                                                                </Tablecell>
                                                                <Tablecell tagid="gr.acc_ass.asset" doctype={docType}>
                                                                    {/* {row.checked === 1 && ( */}
                                                                    {/* <Select
                                                                        tagid="gr.acc_ass.asset"
                                                                        doctype={docType}
                                                                        name={"asset"}
                                                                        id={"asset" + index}
                                                                        value={row.asset}
                                                                        onChange={(event) => this.handleChangeAccountAssignment(event, row._index)}
                                                                        onBlur={(event) => this.handleChangeAccountAssignment(event, row._index, true)}
                                                                        className="asset">
                                                                        <option key={0} value={"-"}>{"-"}</option>
                                                                        <option key={1} value={row.asset}>{row.asset}</option>
                                                                        {t_NEW_ASSET && t_NEW_ASSET.map((newAsset, index) => (
                                                                            <option key={index + 10} value={newAsset.asset_no}>{newAsset.asset_no}</option>
                                                                        ))}
                                                                    </Select> */}
                                                                    <Input
                                                                        key={"service_account_assigment_" + index + "_" + row.asset}
                                                                        tagid="gr.acc_ass.asset"
                                                                        doctype={docType}
                                                                        name={"asset"}
                                                                        id={"asset" + index}
                                                                        type="text"
                                                                        className={`form-control w-100${viewMode ? '' : ' searchable'}`}
                                                                        autocomplete="off"
                                                                        value={row.asset}
                                                                        onClick={(event) => this.openAssetModal(event, index)}
                                                                        viewMode={viewMode}
                                                                        readOnly={true}
                                                                    />
                                                                    {/* )}
                                                                    {(row.checked === 0 || row.checked === "") && (row.asset)} */}
                                                                </Tablecell>
                                                                <Tablecell tagid="gr.acc_ass.acc_order" doctype={docType}>
                                                                    {/* {row.checked === 1 && ( */}
                                                                    <Input
                                                                        key={"service_account_assigment_" + index + "_" + row.acc_order}
                                                                        tagid="gr.acc_ass.acc_order"
                                                                        doctype={docType}
                                                                        type="text"
                                                                        name={"acc_order"}
                                                                        id={"acc_order" + index}
                                                                        className={`form-control w-100 ${viewMode ? '' : 'searchable'}`}
                                                                        autocomplete="off"
                                                                        value={row.acc_order}
                                                                        onClick={(event) => this.openIOModal(event, index)}
                                                                        viewMode={hasPrnoPrefixs ? true : viewMode}
                                                                        readOnly={true}
                                                                    />
                                                                    {/* )}
                                                                    {(row.checked === 0 || row.checked === "") && (row.acc_order)} */}
                                                                </Tablecell>
                                                            </TableRow>
                                                        );
                                                        // } else {
                                                        //     return ""
                                                        // }
                                                    })}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            className="pager"
                                            rowsPerPageOptions={[5, 10, 25]}
                                            component="div"
                                            count={accountAssignment.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            backIconButtonProps={{
                                                "aria-label": "previous page"
                                            }}
                                            nextIconButtonProps={{
                                                "aria-label": "next page"
                                            }}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </div>
                                </div>)}


                                <div className="rrs-detail pt-3">
                                    <div className="row">
                                        <div className="col-md-6 col-lg-4 pr-md-5">
                                            <Div className="col-auto create-button"
                                                tagid="gr.serviceline_acc.add"
                                                doctype={docType}
                                                viewMode={viewMode || showCreateAssetClassType}
                                            >
                                                <span onClick={() => this.createAssetClassType()} className="sp-bt-addmore">
                                                    <i className="icon btn-plus" />
                                                    <span>Create Asset</span>
                                                </span>
                                            </Div>
                                        </div>
                                    </div>
                                </div>

                                <SearchAssetModal withDummy={true} onSelecctAsset={(value) => this.handleSelectAsset(value)} />
                                <SearchIOModal onSelectIO={(value) => this.handleSelectIO(value)} />

                                <NewAsset
                                    isOpen={showCreateAssetClassType}
                                    onGoBack={() => this.goBack()}
                                    onSaveAsset={this.saveAsset}
                                    plants={this.state.plants}
                                    unit_uoms={this.state.unit_uoms}
                                    assetClasses={this.state.assetClasses}
                                />

                                {!showCreateAssetClassType && (
                                    <div className="rrs-detail py-1" style={{ visibility: viewMode ? "hidden" : "visible" }}>
                                        <div className="row sp-table-content-footer">
                                            <div className="col-10 sp-header-button-panel2"></div>
                                            <div className="col-2 sp-header-button-panel2">
                                                <React.Fragment>
                                                    <a href="#" className="sp-btn-icon btn-del" onClick={() => this.closeModal()} data-dismiss="modal">
                                                        <i className="icon btn-order-delete" />
                                                        <span className="sp-btn-icon-label">Close</span>
                                                    </a>
                                                    <a href="#main" className="sp-btn-icon" onClick={this.saveServiceLine}>
                                                        <i className="icon btn-order-savedraft"></i><span className="sp-btn-icon-label">Save</span>
                                                    </a>
                                                </React.Fragment>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>)}
                    </div>
                </div>
            </div >
        )

    }
}

const mapStateToProps = state => {
    const { MainRedux, MasterRedux } = state
    return {
        viewMode: MainRedux.viewMode,
        po_no: MainRedux.po_no,
        t_PO_DETAIL: MainRedux.t_PO_DETAIL,
        t_GR_DETAIL: MainRedux.t_GR_DETAIL,
        t_GR_SERVICE: MainRedux.t_GR_SERVICE,
        t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: [...MainRedux.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT],
        t_GR_SERVICELINE: MainRedux.t_GR_SERVICELINE,
        t_NEW_ASSET: MainRedux.t_NEW_ASSET,
        // serviceLineModal: MainRedux.serviceLineModal,
        currency_code_data: MasterRedux.currency_codes,
        // selectItemGRService: MainRedux.selectItemGRService,
        unit_uom: MasterRedux.unit_uom
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateGR_ServiceLineModal: (data) => dispatch(updateGR_ServiceLineModalAction(data)),
        updateGR_ServiceLine: (data, index = "", fieldName = "", clear = false) => dispatch(updateGR_ServiceLineAction(data, index, fieldName, clear)),
        updateGR_ServiceAccountAssignment: (data, index = "", fieldName = "", clear = false) => dispatch(updateGR_ServiceAccountAssignmentAction(data, index, fieldName, clear)),
        getCostCenter: () => dispatch(getCostCenterAction(null, null, null)),
        getGLAccount: () => dispatch(getGLAccountAction(null, null, null)),
        getBusinessInformation: (requestType, fiscalYear, ioNo, planVersion) => dispatch(getBusinessInformationAction(requestType, fiscalYear, ioNo, planVersion)),
        GETEWHTConditionValidationCheckInquiry: (body) => dispatch(GETEWHTConditionValidationCheckInquiryAction(body)),
        updateNewAsset: (assetNew) => dispatch(updateNewAssetAction(assetNew)),
        setAssetModalOption: (options) => dispatch(setAssetModalOptionAction(options)),
        setModalCostCenterKey: (refKey) => dispatch(setModalCostCenterKeyAction(refKey)),

        getPlantInfo: (purOrg) => dispatch(getPlantInfoAction(purOrg)),
        getUOM: () => dispatch(getUOMAction()),
        getAssetClass: () => dispatch(getAssetClassAction()),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ServiceLineModal)